
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitobhimashankarcabs() {



    const cardData =
    {
        keyword: 'Mumbai to Bhimashankar Cab ',
        heading: 'Skyline Cabs: Mumbai to Bhimashankar Cab',
        headingDescription: 'Skyline Cabs offers dependable and comfortable Mumbai to Bhimashankar Cab service for a serene and spiritual journey to one of the twelve Jyotirlingas of Lord Shiva. Whether you are visiting for religious reasons or to explore the scenic beauty of the Bhimashankar Wildlife Sanctuary, our well-maintained cabs and experienced drivers ensure a safe and smooth ride. With punctual pickups from anywhere in Mumbai, transparent fares, and 24/7 customer support, Skyline Cabs is your trusted travel partner. Book your Mumbai to Bhimashankar cab today and travel with comfort, convenience, and peace of mind.',

        top: 'Top Places to Visit in Bhimashankar with Skyline Cabs',

"topPlaces": [
    {
        "title": "Bhimashankar Temple",
        "description": "One of the 12 Jyotirlingas of Lord Shiva, Bhimashankar Temple is a major pilgrimage site nestled in the Sahyadri Hills. The temple’s Nagara-style architecture and spiritual significance attract devotees and tourists alike."
    },
    {
        "title": "Bhimashankar Wildlife Sanctuary",
        "description": "This lush sanctuary is home to the endangered Indian Giant Squirrel (Shekru) and a variety of flora and fauna. It’s a paradise for nature lovers, bird watchers, and trekkers exploring the dense forests and scenic trails."
    },
    {
        "title": "Gupt Bhimashankar",
        "description": "Located deep in the forest, Gupt Bhimashankar is a hidden and sacred spot believed to be where Lord Shiva appeared in a secret form. It offers a serene and spiritual experience amidst natural beauty."
    },
    {
        "title": "Hanuman Lake",
        "description": "Surrounded by forests and hills, Hanuman Lake is a peaceful spot for picnics, birdwatching, and enjoying nature. It’s often visited during the monsoon when the surroundings are lush and vibrant."
    },
    {
        "title": "Nagphani Point (Duke’s Nose)",
        "description": "Also known as Nagphani due to its snake-like shape, this viewpoint offers panoramic views of the Western Ghats. It’s popular with trekkers and adventure seekers for its thrilling trails and breathtaking vistas."
    },
    {
        "title": "Sahyadri Hills Trekking Trails",
        "description": "Bhimashankar is a hub for trekking enthusiasts with trails winding through dense forests, waterfalls, and ancient shrines. The trails offer a mix of adventure and spiritual exploration."
    },
    {
        "title": "Ahupe Ghat",
        "description": "A picturesque mountain pass near Bhimashankar, Ahupe Ghat is known for its trekking route, stunning valley views, and tribal villages. It’s ideal for offbeat explorers and photographers."
    },
    {
        "title": "Seva Kendra Bhimashankar",
        "description": "An information and assistance center for pilgrims, Seva Kendra provides guidance, lodging details, and helps ensure a smooth temple visit. It reflects the local community's hospitality and devotion."
    },
    {
        "title": "Kundas (Holy Water Tanks)",
        "description": "Near the Bhimashankar Temple, these sacred water tanks are believed to have healing properties. Pilgrims often take a dip here before entering the temple for spiritual cleansing."
    },
    {
        "title": "Manmodi Caves",
        "description": "Located slightly off-route, these ancient Buddhist caves are carved into the rocks and offer a glimpse into historical monastic life. They are perfect for history buffs and peace seekers."
    }
],

"services": [
    {
      "name": "Mumbai to Bhimashankar Cab",
      "description": "Skyline Cabs offers comfortable and reliable taxi services from Mumbai to Bhimashankar, a renowned pilgrimage destination. Our cabs are well-maintained and ready to provide a safe and smooth journey."
    },
    {
      "name": "Mumbai to Bhimashankar One Way Taxi",
      "description": "Book a one-way taxi from Mumbai to Bhimashankar with Skyline Cabs. Whether you are visiting for darshan or simply sightseeing, we offer one-way trips that ensure convenience and comfort."
    },
    {
      "name": "Bhimashankar Darshan Taxi Service",
      "description": "Skyline Cabs provides dedicated taxi services for Bhimashankar darshan. Our professional drivers will guide you to one of the 12 Jyotirlinga temples and ensure a peaceful visit."
    },
    {
      "name": "Taxi from Mumbai to Bhimashankar",
      "description": "For a comfortable and hassle-free journey, choose Skyline Cabs for a taxi ride from Mumbai to Bhimashankar. We ensure timely pick-up, a smooth ride, and drop-off at your destination."
    },
    {
      "name": "Bhimashankar One Day Trip Taxi",
      "description": "Plan a one-day trip to Bhimashankar with Skyline Cabs. Our service includes transportation from Mumbai to Bhimashankar and back in a day, ensuring you make the most of your visit."
    },
    {
      "name": "Taxi for Bhimashankar Temple",
      "description": "Book a taxi with Skyline Cabs for a spiritual visit to Bhimashankar temple. Our cabs are spacious and air-conditioned, providing a comfortable and relaxing ride for you and your companions."
    }
  ],
  "tableData": [
    ["Mumbai to Bhimashankar Cab", "Mumbai to Bhimashankar One Way Taxi"],
    ["Bhimashankar Darshan Taxi Service", "Taxi from Mumbai to Bhimashankar"],
    ["Bhimashankar One Day Trip Taxi", "Taxi for Bhimashankar Temple"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Mumbai to Bhimashankar Cab Service",
        "WhyChoosedescription": "Our Mumbai to Bhimashankar cab service offers a reliable and comfortable ride, ensuring you have a peaceful journey to this revered temple nestled in the Sahyadri mountains."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Cabs",
        "WhyChoosedescription": "Enjoy a comfortable and spacious ride in our well-maintained cabs, perfect for the scenic journey from Mumbai to Bhimashankar. We ensure a relaxing experience for you and your companions."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We offer affordable pricing for your Mumbai to Bhimashankar trip, with no hidden charges. Our transparent pricing ensures you get great value for your journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are professional, well-trained, and familiar with the best routes to Bhimashankar. They prioritize your safety and comfort during the entire journey."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "Our vehicles are regularly serviced, sanitized, and thoroughly cleaned to provide a safe, hygienic, and comfortable travel experience for your trip to Bhimashankar."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages",
        "WhyChoosedescription": "We offer flexible travel packages for your Mumbai to Bhimashankar trip, whether it's a one-day visit or a longer pilgrimage. Customize your journey to fit your schedule."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Easy Booking",
        "WhyChoosedescription": "Booking your Mumbai to Bhimashankar cab is easy with our 24/7 customer support, available online or over the phone. Get instant booking confirmation and a seamless experience."
    },
    {
        "WhyChooseheading": "Ideal for Spiritual and Group Travel",
        "WhyChoosedescription": "Our cabs are perfect for solo pilgrims, family groups, or friends traveling together to Bhimashankar, providing a comfortable and safe experience during your spiritual journey."
    }
]







    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Mumbai to Bhimashankar with Skyline Cabs?',
            answer:
                'Booking a cab from Mumbai to Bhimashankar is easy. You can book through our website, mobile app, or by calling our customer support. Just enter your pickup location, travel date, and select your preferred vehicle for the journey.',
        },
        {
            id: 2,
            question: 'What is the distance and travel time from Mumbai to Bhimashankar?',
            answer:
                'The distance from Mumbai to Bhimashankar is approximately 120 km, and the journey typically takes around 3 to 4 hours, depending on traffic and road conditions.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for the Mumbai to Bhimashankar trip?',
            answer:
                'We offer a variety of vehicles including Swift Dzire, Ertiga, Innova Crysta, Kia Carens, and SUVs for this route. For larger groups, Tempo Travellers and Force Urbania are available.',
        },
        {
            id: 4,
            question: 'Are your cab fares for Mumbai to Bhimashankar fixed?',
            answer:
                'Yes, we offer fixed and transparent fares that include vehicle rental, driver charges, tolls, taxes, and fuel. You’ll know the total fare before confirming your booking.',
        },
        {
            id: 5,
            question: 'Can I book a one-way cab from Mumbai to Bhimashankar?',
            answer:
                'Yes, we offer one-way cab options for your convenience. You can also choose a round-trip service if you need to return to Mumbai on the same day or the next day.',
        },
        {
            id: 6,
            question: 'Is the route to Bhimashankar safe for travel?',
            answer:
                'Yes, the route is safe, but it involves ghat sections, so it’s essential to travel with an experienced driver. Our drivers are well-versed in the route and ensure your safety and comfort during the journey.',
        },
        {
            id: 7,
            question: 'Are stopovers allowed during the journey to Bhimashankar?',
            answer:
                'Yes, short stopovers for refreshments, meals, or sightseeing are allowed. Let the driver know in advance if you wish to take a break or explore any other locations along the way.',
        },
        {
            id: 8,
            question: 'What payment options are available for the Mumbai to Bhimashankar cab?',
            answer:
                'We accept multiple payment options including UPI, credit/debit cards, net banking, and cash payments after the trip. All online payments are secure and hassle-free.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my Mumbai to Bhimashankar cab booking?',
            answer:
                'Yes, you can modify or cancel your booking through our app, website, or by contacting customer support. We offer flexible cancellation policies to accommodate changes in your plans.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for the Mumbai to Bhimashankar trip?',
            answer:
                'Skyline Cabs offers reliable service, experienced drivers, clean vehicles, and transparent pricing. We ensure a comfortable, safe, and pleasant journey to Bhimashankar with excellent customer service.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "I booked a cab from Mumbai to Bhimashankar with Skyline Cabs. The car was comfortable, the driver was experienced, and the entire trip was smooth. Highly recommend for temple visits!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "The journey from Mumbai to Bhimashankar was very comfortable with Skyline Cabs. The driver was knowledgeable, and we made it to the temple in good time. Would definitely book again!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Bhimashankar Cab",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-bhimashankar-cab.jpg",
  "description": "Book Mumbai to Bhimashankar cab with Skyline Cabs for a comfortable pilgrimage to the sacred Jyotirlinga temple. AC sedans, SUVs, and tempo travellers available with professional drivers for safe and peaceful travel.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8493"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3600",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-bhimashankar-cab"
  }
};



      
     
      


    return (
        <div>
<Helmet>
  <title>Mumbai to Bhimashankar Cab | Jyotirlinga Darshan Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Bhimashankar cab with Skyline Cabs for a comfortable pilgrimage to the sacred Jyotirlinga temple. AC sedans, SUVs, and tempo travellers available with professional drivers for safe and peaceful travel." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Bhimashankar Cab, Bhimashankar Jyotirlinga Cab from Mumbai, Darshan Cab Mumbai Bhimashankar, AC Cab Bhimashankar Mumbai, SUV Taxi Bhimashankar, Bhimashankar Yatra from Mumbai, Skyline Cabs Bhimashankar Darshan" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/83.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitobhimashankarcabs;